<div id="loading">
    <div id="loading-center">
        <img src="./assets/sofbox-v2/images/logo.png" alt="loader">
    </div>
</div>
<!-- Header Component Start-->
<app-v-two-header-style1 [logoImg]="navLogo" [logoWhite]="logoWhite" [logoClass]="logoClass" className="iq-gradient main-header" [navItemList]="navItems"></app-v-two-header-style1>
<!-- Header Component End-->
<!-- START sofbox6 REVOLUTION SLIDER 6.1.3 -->
<app-slider></app-slider>
<!--End sofbox2 REVOLUTION SLIDER -->
<!-- Main Content -->
<div class="main-content">
    <app-features></app-features>
    <app-how-work></app-how-work>
    <app-business-need></app-business-need>
    
    <!-- <app-testimonial></app-testimonial>
    <app-post></app-post> -->
</div>
<!-- End Main content -->
<app-v-two-footer-style2 [footerLogo]="footerLogo" [footerText]="footerText" [footerTitle]="footerTitle" [footerDescription]="footerDescription">
   <ul menu>
        <li>
            <a style="display: flex; align-items: center; gap: 5px;" class="text-white" href="javascript:void(0)"><i class="ion-ios-email-outline"></i><span> talent@worthgrowth.com</span> </a>
        </li>

    </ul>
</app-v-two-footer-style2>